import secureLocalStorage from "react-secure-storage";

//null값을 주면 로그인한 회원 정보가 나타난다.
const USER_IDENTITY = null;

export default USER_IDENTITY;